<div id="wrapper">
  <!--<app-navigation [loginInfo]="loginInfo" *ngIf="loginInfo"></app-navigation>-->

  <div id="page-wrapper" class="light-blue-background">

    <app-topnavbar></app-topnavbar>

    <router-outlet></router-outlet>
  </div>
</div>